export default "__VITE_ASSET__B59KPIzu__"